import { Button, Link, TextField, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Dialog } from 'shared/components';

export default function ReportProblemButton() {
    const { t } = useTranslation('navigation');
    const [ isOpen, setIsOpen ] = useState(false);
    const [ comment, setComment ] = useState('');
    const [ isSubmitted, setIsSubmitted ] = useState(false);

    const handleOpen = useCallback(() => {
        setIsOpen(true);
        setComment('');
        setIsSubmitted(false);
    }, []);

    const handleClose = useCallback(() => {
        setIsOpen(false);
    }, []);

    const handleSubmit = useCallback(() => {
        // eslint-disable-next-line no-underscore-dangle
        window.__diagnostics?.reportProblem(comment || undefined, () => {
            setIsSubmitted(true);
        });
    }, [ comment ]);

    return (
        <>
            <StyledLink component={ Link }
                variant="body2"
                onClick={ handleOpen }
            >
                { t('navigationItem.reportProblem') }
            </StyledLink>

            <Dialog open={ isOpen }
                onClose={ handleClose }
                variant="dialog"
                title={ t('reportProblem.title') }
                actions={ isSubmitted
                    ? <Button variant="contained"
                        onClick={ handleClose }>{ t('reportProblem.close') }</Button>
                    : (
                        <>
                            <Button onClick={ handleClose }>{ t('reportProblem.cancel') }</Button>
                            <Button variant="contained"
                                onClick={ handleSubmit }>{ t('reportProblem.submit') }</Button>
                        </>
                    ) }
            >
                { isSubmitted
                    ? <>{ t('reportProblem.success') }</>
                    : (
                        <TextField
                            multiline
                            minRows={ 3 }
                            maxRows={ 6 }
                            fullWidth
                            placeholder={ t('reportProblem.placeholder') }
                            value={ comment }
                            onChange={ (e) => setComment(e.target.value) }
                        />
                    ) }
            </Dialog>
        </>
    );
}

const StyledLink = styled(Typography)({
    cursor: 'pointer',
    textDecoration: 'none',
    fontSize: 12
}) as typeof Typography;
